module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/SZ-9cbbb57f78133e6e0db53f874eb8e02a.png";